<div class="cds-modal">
  @if (showHeader) {
    <div class="cds-modal-header">
      <div class="header-title">{{ headerTitle }}</div>
      @if (showCloseModal) {
        <i
          class="cds-icon-close"
          (click)="modalRef.close()"
        ></i>
      }
    </div>
  }

  <div [class]="'cds-modal-content'">
    <ng-container [ngSwitch]="contentType">

      <ng-container *ngSwitchCase="'string'">
        <div [innerHTML]="content"></div>
      </ng-container>

      <ng-container *ngSwitchCase="'template'">
        <ng-container *ngTemplateOutlet="templateContent; context: context"/>
      </ng-container>

      <ng-container *ngSwitchCase="'component'">
        <ng-container *ngComponentOutlet="componentContent"/>
      </ng-container>

    </ng-container>
  </div>
</div>
